import "./index.css";
import App from "./app";
import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import { DISABLE_SERVICE_WORKER } from "@/constants";
import { NetworkStatusProvider } from "@/hooks/index";
import { registerServiceWorker } from "./serviceWorkerRegistration";
import KeepAlive from "react-activation";
import { maybeApplyForcedCacheReset } from "@/shared/maybeApplyForcedCacheReset";
import { hydrateAppTablesFromIdb } from "@/shared/appTablesIdbStorage";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

(KeepAlive as any).defaultProps = {
  ...(KeepAlive as any).defaultProps,
  autoFreeze: false,
};

void maybeApplyForcedCacheReset().then(async (didReset) => {
  if (didReset) {
    window.location.reload();
    return;
  }

  await hydrateAppTablesFromIdb();

  root.render(
    //<React.StrictMode>
    <NetworkStatusProvider>
      <App />
    </NetworkStatusProvider>
    //</React.StrictMode>
  );

  if (!DISABLE_SERVICE_WORKER) registerServiceWorker();
  reportWebVitals();
});

